module.exports = __webpack_public_path__ + "static/media/07.55c5621a.jpg";